/* HOW TO USE

example:
<s-search-staff-muti
  v-model="euids"
  showSupportStaff
  showGroup
  @dataChange="staffObjArray = $event"
  label="主管"
/>

*/

<template>
  <!-- don't cache-items, it will cause the emitChange method cannot find the staff object to emit -->
  <v-autocomplete
    ref="autocomplete"
    class="search-staff"
    :value="localValue"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    hide-no-data
    item-text="sDesc"
    item-value="sId"
    :label="label"
    :placeholder="placeholder"
    :outlined="outlined"
    :dense="dense"
    :clearable="clearable"
    :background-color="backgroundColor"
    :hint="showGroup ? $t('SearchStaff.OnlyShowStaffWithEuidAndValidGroup') : $t('SearchStaff.OnlyShowStaffWithEuid')"
    :filled="filled"
    persistent-hint
    :hide-details="hideDetails"
    :rules="rules"
    chips
    multiple
    @change="emitChange($event)"
  >
    <template v-slot:selection="data">
      <v-chip
        v-if="data.item.euid"
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        :small="dense"
        @click="data.select"
        @click:close="remove(data.item)"
      >
        {{ nvl(data.item.chinName, '') + ' ' + nvl(data.item.portName, '') }}
      </v-chip>
      <v-chip
        v-else
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        :small="dense"
        @click="data.select"
        @click:close="remove(data.item)"
      >
        {{ nvl(data.item.definedGroupChinName, '') + ' ' + nvl(data.item.definedGroupPortName, '') }}
      </v-chip>
    </template>

    <template v-slot:item="data">
      <template v-if="(typeof data.item) !== 'object'">
        <v-list-item-content v-text="data.item" />
      </template>
      <template v-else>
        <v-list-item-content>
          <v-list-item-title>{{ staffToString(data.item) }}</v-list-item-title>
          <v-list-item-subtitle v-html="data.item.group" />
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<style>
  .v-autocomplete.v-select.v-input--is-focused.search-staff input {
    min-width: 0;
    min-width: initial;
  }
</style>

<script>

import autocompleteMutiMixin from './mixins/autocompleteMutiMixin'
import g2eApi from '@/api/hr/g2e'
import { SEARCH_STAFF_RECORD_TYPE } from '@/constant/constant'
import { nvl } from '@/utils/stringUtil'

export default {
  name: 'SSearchStaffMutiNew',
  mixins: [autocompleteMutiMixin],
  props: {
    showSupportStaff: {
      type: Boolean,
      default: false
    },
    showGroup: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    staffToString: function (staff) {
      if (staff.recordType && (staff.recordType === SEARCH_STAFF_RECORD_TYPE.GROUP)) {
        return `${staff.definedGroupAbbr} - ${staff.definedGroupChinName} ${staff.definedGroupPortName}`
      } else {
        return `${nvl(staff.portName, '')} ${nvl(staff.chinName, '')} ${staff.nickName ? '(' + staff.nickName + ')' : ''} ${staff.euid}`
      }
    },
    dataToDescAndId: function (staff) {
      let id = staff.euid
      if (staff.recordType && (staff.recordType === SEARCH_STAFF_RECORD_TYPE.GROUP)) {
        id = staff.definedGroupId + ''
      }
      return { sId: id, sDesc: this.staffToString(staff) }
    },
    callApi: function (cb, finalCb, val, isPropUpdated) {
      let searchByGroupId = false
      if (isPropUpdated) {
        searchByGroupId = !val.startsWith('E')
      }
      if (this.showSupportStaff && this.showGroup) {
        return g2eApi.searchStaffsWithEntityAdministrativeSupportAndDefinedGroups(cb, finalCb, val, searchByGroupId)
      } else if (this.showSupportStaff) {
        return g2eApi.searchStaffsWithEntityAdministrativeSupport(cb, finalCb, val)
      } else if (this.showGroup) {
        return g2eApi.searchStaffsWithDefinedGroups(cb, finalCb, val, searchByGroupId)
      } else {
        return g2eApi.searchStaff(cb, finalCb, val)
      }
    },
    nvl
  }
}
</script>
